export default "__VITE_ASSET__CE4rx8Xf__"